<template>
  <div :class="[$style.wrapper, !isOpen ? $style.hide : null]" v-if="object">
    <div
      v-if="this.isOpen"
      :class="[$style.back, { [$style.deleteIndent]: this.$store.state.deleteIndent }]"
      @click="backToOpenCard"
    >
      <img src="../assets/img/back.svg" alt="" />
    </div>
    <div :class="$style.content" :style="contentStyle">
      <div :class="$style.header">
        <h1 :class="$style.title">Заполните заявку</h1>
        <p :class="$style.subtitle">и наши специалисты свяжутся с вами</p>
      </div>
      <div :class="$style.bid">
        <input
          v-model="formUser.firstName"
          type="text"
          placeholder="Имя*"
          :class="[$style.button_transparent, errorMessages.firstName ? $style.errorInput : '']"
        />
        <div v-if="errorMessages.firstName" :class="$style.error">
          {{ errorMessages.firstName }}
        </div>

        <input
          v-model="formUser.email"
          type="email"
          placeholder="Почта"
          :class="[$style.button_transparent, errorMessages.email ? $style.errorInput : '']"
        />
        <div v-if="errorMessages.email" :class="$style.error">{{ errorMessages.email }}</div>

        <input
          v-model="formUser.phone"
          type="tel"
          placeholder="Номер телефона*"
          :class="[$style.button_transparent, errorMessages.phone ? $style.errorInput : '']"
          ref="phoneInput"
        />
        <div v-if="errorMessages.phone" :class="$style.error">{{ errorMessages.phone }}</div>

        <div v-if="errorMessage" :class="$style.error">{{ errorMessage }}</div>

        <button
          :class="[$style.button, isSubmitted ? $style.success : '']"
          @click="handleSubmit"
          :disabled="isSubmitted"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Inputmask from 'inputmask';

export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: true,
      isSubmitted: false,
      buttonText: 'Отправить',
      formUser: {
        firstName: '',
        email: '',
        phone: '',
      },
      errorMessages: {
        firstName: '',
        email: '',
        phone: '',
      },
      errorMessage: '',
      contentStyle: {},
    };
  },
  mounted() {
    const phoneInput = this.$refs.phoneInput;
    const im = new Inputmask('+7(999)999-99-99');
    im.mask(phoneInput);
    window.Telegram.WebApp.BackButton.onClick(() => {
      this.backToOpenCard();
    });
  },
  methods: {
    validateForm() {
      let isValid = true;

      if (!this.formUser.firstName) {
        this.errorMessages.firstName = 'Пожалуйста, введите имя';
        isValid = false;
      } else {
        this.errorMessages.firstName = '';
      }

      if (this.formUser.email && !this.validateEmail(this.formUser.email)) {
        this.errorMessages.email = 'Пожалуйста, введите корректный email';
        isValid = false;
      } else {
        this.errorMessages.email = '';
      }

      if (!this.formUser.phone) {
        this.errorMessages.phone = 'Пожалуйста, введите номер телефона';
        isValid = false;
      } else if (!this.validatePhone(this.formUser.phone)) {
        this.errorMessages.phone = 'Пожалуйста, введите корректный номер телефона';
        isValid = false;
      } else {
        this.errorMessages.phone = '';
      }

      return isValid;
    },

    validateName(name) {
      return name.trim().length > 0;
    },

    validateEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },

    validatePhone(phone) {
      const phoneRegex = /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/;
      return phoneRegex.test(phone);
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.errorMessage = '';
      this.isSubmitted = true;
      this.buttonText = 'Заявка успешно отправлена!';

      const formData = {
        name: this.formUser.firstName,
        email: this.formUser.email,
        phone: this.formUser.phone,
        link: this.link,
      };

      this.$store.commit('changeLoading', true);
      await this.$store.dispatch('submitForm', formData);
      this.$store.commit('changeLoading', false);
    },

    backToOpenCard() {
      this.isOpen = false;
      setTimeout(() => {
        this.$emit('backToOpenCard');
      }, 250);
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}

@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.wrapper {
  position: fixed;
  z-index: 50;
  background: $background;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation: show 0.25s ease;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow: hidden;
  &.hide {
    animation-name: hide;
    animation-duration: 0.26s;
  }
}

.content {
  position: absolute;
  width: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px;
}

.back {
  position: absolute;
  top: 116px;
  left: 16px;
  margin-bottom: 71px;
  width: 39px;
  height: 39px;
}

.deleteIndent {
  top: 16px;
}

.header {
  margin: 0 auto;
  text-align: center;
  margin-bottom: 16px;
}

.title {
  font-weight: 800;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 1px;
  color: $primary;
}

.subtitle {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  color: $white;
}

.button_transparent {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 14px 0px 14px 16px;
  width: 100%;
  background-color: transparent;
  color: $white;
  border: 1px solid $white;
  border-radius: 12px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.button_transparent::placeholder {
  color: $white;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.error {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  color: $red;
  margin: 0 auto;
  margin-bottom: 10px;
  text-align: center;
}

.button {
  margin: 20px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $black;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}

.button.success {
  background-color: #27d045;
  color: $white;
}
</style>
